var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iw-breadcrumb',{attrs:{"separator":">"}},[_c('iw-breadcrumb-item',{attrs:{"to":{ path: '/enterprise' }}},[_vm._v(" 企业动态分析 ")]),_c('iw-breadcrumb-item',{attrs:{"to":"/enterprise/brand-overview"}},[_vm._v(" 厂商品牌概况 ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }